var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rest } from "../../Rest";
export class AvpAPILegacy extends Rest {
    constructor(baseUrl, tenantToken, isoCountryCode) {
        super(baseUrl);
        this.isoCountryCode = isoCountryCode;
        this.name = "AvpAPI";
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", tenantToken);
    }
    getAvailableMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            const { statusCode, data } = yield this.request(`/available-methods/${this.isoCountryCode}`, {
                method: "GET",
            });
            return Promise.resolve({
                data,
                statusCode,
            });
        });
    }
    isAgeVerificationHidden() {
        return __awaiter(this, void 0, void 0, function* () {
            const { has_hidden_verification } = yield this.request("/has-hidden-verification", {
                method: "GET",
            });
            return has_hidden_verification;
        });
    }
    verify(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request("/verify", {
                method: "POST",
                // TODO: Need to fix proper types to normally pass this variable
                body: JSON.stringify(Object.assign(Object.assign({}, variables), (variables.fields && {
                    fields: Object.assign(Object.assign(Object.assign({}, variables.fields), (variables.fields.workflowName && { workflow_name: variables.fields.workflowName })), (variables.fields.workflowDefinitionId && {
                        workflow_definition_id: variables.fields.workflowDefinitionId,
                    })),
                }))),
            }, true);
        });
    }
    initAsyncVerification(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request("/init-async-verification", {
                method: "POST",
                body: JSON.stringify(Object.assign({ user_email: payload.userEmail, method_code: payload.methodCode, country_code: this.isoCountryCode }, (payload.fields && {
                    fields: {
                        callback: payload.fields.callback,
                        firstName: payload.fields.firstName,
                        lastName: payload.fields.lastName,
                        dateOfBirth: payload.fields.dateOfBirth,
                        workflow_name: payload.fields.workflowName,
                        workflow_definition_id: payload.fields.workflowDefinitionId,
                        identity_verification_id: payload.fields.identity_verification_id,
                    },
                }))),
            }, true);
        });
    }
}
//# sourceMappingURL=AvpAPILegacy.js.map